module.exports = __webpack_public_path__ + "static/media/about_home.5022eaaf.jpg";